import log from 'common/services/logging/loggers';

(() => {

    const _serviceDependencies = ['jwtHelper'];

    /**
    * @ngdoc service
    * @name Util.JWT
    *
    * @description
    * This class is used to process a JWT token
    */
    class JWT {

        constructor(jwtHelper) {

            this.jwtHelper = jwtHelper;

        }

        /**
         * @ngdoc function
         * @name Util.JWT#getTokenPayload
         * @methodOf  Util.JWT
         * @function
         *
         * @description
         * This function returns the decoded JWT token if it exists
         * if not it will return undefined
         */
        getTokenPayload(token) {

            if (token) {

                try {

                    return this.jwtHelper.decodeToken(token);

                } catch (err) {

                    const body = angular.element('body');

                    body.append(`${'<div class="testing" style="width:300px; padding:5px;' +
                        'background-color:#727272; position:fixed; top:0; color:#fff; max-height:300px;' +
                        'z-index:1000; font-size:14px; word-break:break-word; overflow:auto;">'}${
                        err}</div>`);

                    log.error(err);
                    return undefined;

                }

            }

            return undefined;

        }

    }

    _serviceDependencies.push(JWT);

    angular.module('services')
        .service('JWT', _serviceDependencies);

})();



// WEBPACK FOOTER //
// ./scripts/common/services/util/JWT.js